import { FieldType, MagazineNewspaperPublicationField, TvRadioField } from '../../../../components/GenericSection';
import { RowType } from '../../../../components/GenericSection/types';
export var TV_RADIO_PUBINFO_SECTION_FIELDS = [{
  field: TvRadioField.TITLE,
  labelText: 'Source title',
  type: FieldType.TEXT
}, {
  field: TvRadioField.CALL,
  labelText: 'Call',
  type: FieldType.TEXT
}, {
  field: TvRadioField.NETWORK,
  labelText: 'Network',
  type: FieldType.TEXT
}, {
  rowtype: RowType.SM_TWO_ROW,
  fields: [{
    field: MagazineNewspaperPublicationField.EDITION,
    labelText: 'City',
    type: FieldType.TEXT
  }, {
    field: MagazineNewspaperPublicationField.SECTION,
    labelText: 'State',
    type: FieldType.TEXT
  }]
}, {
  type: FieldType.PUBDATE,
  labelText: 'Date aired',
  field: TvRadioField.DATE,
  formikFieldNames: ['day', 'month', 'year']
}, {
  type: FieldType.RADIO,
  labelText: 'Medium',
  options: [{
    key: 'television',
    value: 'Television'
  }, {
    key: 'radio',
    value: 'Radio'
  }],
  field: TvRadioField.MEDIUM,
  alignment: 'vertical'
}];